import React from 'react';
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from '@mui/material';
import { toast } from 'react-toastify';

const SuccessDialog = ({ open, onClose, successDetails, isDark, isMobile }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      fullScreen={isMobile}
    >
      <DialogTitle sx={{
        background: isDark ? '#ffffff' : '#171717',
        color: isDark ? '#050505' : '#ffffff',
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        fontWeight: 700,
      }}>
        {successDetails.title || 'Success'}
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.primary' }}>
          {successDetails.message}
        </Typography>
        {successDetails.chainName && (
          <Typography variant="body2" sx={{ mb: 1, color: 'text.secondary' }}>
            Chain: {successDetails.chainName}
          </Typography>
        )}
        {successDetails.txHash && (
          <Box sx={{
            bgcolor: 'rgba(0, 242, 254, 0.08)',
            border: '1px solid rgba(0, 242, 254, 0.2)',
            p: 1.5,
            borderRadius: 1,
            mb: 2,
          }}>
            <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mb: 0.5 }}>
              Transaction Hash (click to copy)
            </Typography>
            <Typography variant="body2" sx={{
              fontFamily: 'monospace',
              fontSize: '0.8rem',
              wordBreak: 'break-all',
              cursor: 'pointer',
              color: '#22c55e',
            }}
              onClick={() => {
                navigator.clipboard.writeText(successDetails.txHash);
                toast.info('Transaction hash copied!');
              }}
              title="Click to copy"
            >
              {successDetails.txHash}
            </Typography>
          </Box>
        )}
        {successDetails.explorerUrl && (
          <Button
            variant="outlined"
            size="small"
            href={successDetails.explorerUrl}
            target="_blank"
            rel="noopener noreferrer"
            fullWidth
            sx={{
              textTransform: 'none',
              borderColor: 'rgba(0, 242, 254, 0.4)',
              color: '#22c55e',
              '&:hover': {
                borderColor: '#22c55e',
                bgcolor: 'rgba(0, 242, 254, 0.1)',
              },
            }}
          >
            View on Block Explorer
          </Button>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            background: isDark ? '#ffffff' : '#171717',
            color: isDark ? '#050505' : '#ffffff',
            fontWeight: 600,
            '&:hover': {
              background: isDark ? '#d4d4d4' : '#404040',
            },
          }}
        >
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SuccessDialog;
